import { CSSProperties, useContext, useEffect, useState } from "react";
import "./FeedbackOverview.css";
import Label from "../Modules/Label";
import { PrimaryButton } from "../Modules/PrimaryButton";
import QuestContext from "../QuestWrapper";
import { blackStar, deleteSvg, fileSvg, screenshotSvg, whiteStar } from "./SVG";
import { LabelModule2 } from "../Modules/LabelModule2";

export interface GeneralFeedbackContentStyleConfig {
  Form?: React.CSSProperties;
  Heading?: React.CSSProperties;
  Description?: React.CSSProperties;
  Input?: React.CSSProperties;
  Label?: React.CSSProperties;
  EmailError?: {
    text?: string,
    errorStyle?: React.CSSProperties
  },

  TopBar?: React.CSSProperties;
  TextArea?: React.CSSProperties;
  PrimaryButton?: React.CSSProperties;
  SecondaryButton?: React.CSSProperties;
  Modal?: React.CSSProperties;
  Footer?: React.CSSProperties;
  listHeading?: React.CSSProperties;
  listDescription?: React.CSSProperties;
  Card?: React.CSSProperties;
  Star?: {
    Style?: React.CSSProperties;
    PrimaryColor?: string;
    SecondaryColor?: string;
    Size?: number;
  }
  listHover?: {
    background?: string;
    iconBackground?: string;
    iconColor?: string;
    Heading?: string;
    Description?: string;
    IconSize?: string;
    Icon?: React.CSSProperties;
  };
  ThanksPopup?: {
    Style?: React.CSSProperties;
    Heading?: React.CSSProperties;
    Description?: React.CSSProperties;
    ShowFooter?: boolean;
    Icon?: React.CSSProperties;
  },
}
export interface GeneralFeedbackContentProps {
  starColor?: string;
  btnTextColor?: string;
  starBorderColor?: string;
  formdata: Array<{ [key: string]: any }>;
  handleSubmit: () => void;
  handleUpdate: (e: any, id: string, j: string, k?: number) => void;
  answer: any;
  handleRemove?: (e: any) => void;
  ratingStyle?: "Star" | "Numbers" | "Smiles";
  labelStyle?: CSSProperties;
  normalInput: (
    question: string,
    criteriaId: string,
    placeholder?: string,
    required?: boolean
  ) => JSX.Element;
  emailInput: (
    question: string,
    criteriaId: string,
    placeholder?: string,
    required?: boolean
  ) => JSX.Element;
  normalInput2: (
    question: string,
    criteriaId: string,
    placeholder?: string,
    required?: boolean
  ) => JSX.Element;
  iconColor?: string;
  buttonStyle?: CSSProperties;
  PrimaryButtonText?: string;
  StarStyle?: {
    Style?: React.CSSProperties;
    PrimaryColor?: string;
    SecondaryColor?: string;
    Size?: number;
  };
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  screenshot: FileProp | null;
  onStartCapture: () => void;
  setScreenshot: (screenshot: FileProp | null) => void;
  uploadFileToBackend: (file: any) => any;
  inputRef: React.MutableRefObject<HTMLInputElement | null>;
  file: FileProp | null;
  setFile: (file: FileProp | null) => any;
  styleConfig?: GeneralFeedbackContentStyleConfig,
  BrandTheme?: BrandTheme,
  QuestThemeData?: QuestThemeData,
  rating: number,
  setRating: (rating: number) => void
}

type BrandTheme = {
  accentColor?: string;
  background?: string;
  borderRadius?: string;
  buttonColor?: string;
  contentColor?: string;
  fontFamily?: string;
  logo?: string;
  primaryColor?: string;
  secondaryColor?: string;
  tertiaryColor?: string;
  titleColor?: string;
}

interface QuestThemeData {
  accentColor: string;
  theme: string;
  borderRadius: string;
  buttonColor: string;
  images: string[]

}

interface FileProp {
  name: string;
  size: number;
  type: string;
  lastModified: number;
  webkitRelativePath: string;
}
const GeneralFeedbackContent: React.FC<GeneralFeedbackContentProps> = ({
  formdata,
  handleUpdate,
  handleSubmit,
  ratingStyle,
  normalInput,
  emailInput,
  normalInput2,
  answer,
  buttonStyle = {},
  labelStyle = {},
  PrimaryButtonText = "Submit",
  StarStyle,
  isVisible,
  setIsVisible,
  screenshot,
  setScreenshot,
  onStartCapture,
  uploadFileToBackend,
  inputRef,
  file,
  setFile,
  styleConfig,
  BrandTheme,
  QuestThemeData,
  starBorderColor,
  rating,
  setRating
}) => {
  const handleRatingChange2 = (e: any, id: any, rating: number) => {
    setRating(rating);
    handleUpdate(e, id, "", rating);
  };

  const { themeConfig } = useContext(QuestContext.Context);

  // const handleUploadImages = async (e: any) => {
  const handleUploadImages = async (e: any) => {
    e.preventDefault();
    let urlArr = [];
    if (file !== null) {
      let url = await uploadFileToBackend(file);
      urlArr.push(url);
    }
    if (screenshot !== null) {
      let url = await uploadFileToBackend(screenshot);
      urlArr.push(url);
    }
    for (let i = 0; i < formdata.length; i++) {
      if (formdata[i].type === "USER_INPUT_IMAGE") {
        answer[formdata[i].criteriaId] = urlArr;
        break;
      }
    }
    handleSubmit();
    setFile(null);
    setScreenshot(null);
  };

  return (
    <form className="q-fdov-ch-boxes" onSubmit={handleUploadImages}>
      {formdata?.length > 0 ? (
        <>
          {formdata.map((data: any) => {
            if (data.type === "USER_INPUT_TEXT") {
              return normalInput(
                data.question || "",
                data.criteriaId || "",
                data.placeholder || "",
                data.required || false
              );
            } else if (data.type === "USER_INPUT_EMAIL") {
              return emailInput(
                data.question || "",
                data.criteriaId || "",
                data.placeholder || "",
                data.required || false
              );
            } else if (data.type === "USER_INPUT_TEXTAREA") {
              return normalInput2(
                data.question || "",
                data.criteriaId || "",
                data.placeholder || "",
                data.required || false
              );
            } else if (data.type === "RATING") {
              return (
                <div key={data.criteriaId}>
                  <LabelModule2
                    htmlFor={"normalInput"}
                    children={
                      data.question
                        ? data.question
                        : "How would you rate your experience ?"
                    }
                    style={labelStyle}
                  />
                  <div>
                    {ratingStyle == "Numbers" || data.ratingType == "Numbers" ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: "4px",
                        }}
                      >
                        {Array(data.scale || 5).fill(1).map((num, index) => (
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "400",
                              minWidth: "35px",
                              color: num + index <= rating ? "#FFF" : "#8E8E8E",
                              borderRadius: "10px",
                              border:
                                num + index <= rating
                                  ? "2px solid var(--neutral-grey-100, #000)"
                                  : "2px solid var(--neutral-grey-100, #ECECEC)",
                              background: num + index <= rating ? "#000" : "#fff",
                              padding: "10px 12px",
                              textAlign: "center",
                              cursor: "pointer",
                              boxSizing: "content-box",
                            }}
                            key={index}
                            onClick={(e) =>
                              handleRatingChange2(e, data.criteriaId, num + index)
                            }
                          >
                            {num + index}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          ...StarStyle?.Style,
                        }}
                      >
                        {[1, 2, 3, 4, 5].map((star) => (
                          <div
                            style={{
                              width: `${StarStyle?.Size}px` || "32px",
                              height: `${StarStyle?.Size}px` || "32px",
                              lineHeight: `${StarStyle?.Size}px` || "32px",
                              cursor: "pointer",
                            }}
                            key={star}
                            onClick={(e) =>
                              handleRatingChange2(e, data.criteriaId, star)
                            }
                          >
                            {star <= rating
                              ? blackStar(
                                StarStyle?.Size,
                                StarStyle?.PrimaryColor,
                                starBorderColor
                              )
                              : whiteStar(
                                StarStyle?.Size,
                                StarStyle?.SecondaryColor,
                                starBorderColor
                              )}
                          </div>
                        ))}
                      </div>
                    )}
                    {ratingStyle && ratingStyle !== "Star" && <div className={"ratingTextView"}>
                      <div className={"ratingText"} >
                        {data?.leftText || "Not likely"}
                      </div>
                      <div className={"ratingText"} >
                        {data?.rightText || "Very Likely"}
                      </div>
                    </div>}
                    {data.ratingType && data.ratingType !== "Star" && <div className={"ratingTextView"}>
                      <div className={"ratingText"} >
                        {data?.leftText || "Not likely"}
                      </div>
                      <div className={"ratingText"} >
                        {data?.rightText || "Very Likely"}
                      </div>
                    </div>}
                  </div>
                </div>
              );
            } else if (data.type === "USER_INPUT_IMAGE") {
              return (
                <div className='q-fdov-image-input q-gen-img-upl'>
                  <div className="q-gen-img-upl-btns">
                    <div className="gen-upl-btn-1">
                      <button
                        style={{
                          borderColor: themeConfig.borderColor,
                          border: styleConfig?.Input?.border || "1px solid #ECECEC",
                          ...styleConfig?.Input,
                          opacity: screenshot === null ? 1 : 0.5,
                        }}
                        disabled={screenshot !== null}
                        onClick={() => {
                          setIsVisible(!isVisible);
                          onStartCapture();
                        }}
                      >
                        {screenshotSvg(styleConfig?.PrimaryButton?.color)}
                      </button>
                    </div>

                    <div className="gen-upl-btn-2">
                      <div style={{
                        borderColor: themeConfig.borderColor,
                        border: styleConfig?.Input?.border || "1px solid #ECECEC",
                        ...styleConfig?.Input,
                        opacity: file === null ? 1 : 0.5,
                      }}
                      // disabled={file !== null}
                      >
                        <label className="q-button-sm q-fw-normal " htmlFor="feed-back-up-img" style={{
                          cursor: file === null ? "pointer" : "no-drop",
                        }}>
                          {fileSvg(styleConfig?.PrimaryButton?.color)}
                        </label>
                        <input type="file" style={{
                          display: "none"
                        }} ref={inputRef} onChange={(e) => {
                          if (e.target.files && e.target.files.length > 0) {
                            const selectedFile = e.target.files[0];
                            setFile(selectedFile);
                          }
                        }} disabled={file !== null} accept='image/*' id="feed-back-up-img" />
                      </div>
                    </div>
                  </div>
                  {screenshot !== null &&
                    (
                      <div className="q-fdov-file-name q-gen-screen-shot-name"
                        style={{
                          border: styleConfig?.Input?.border || "1px solid #ECECEC"
                        }}
                      >
                        <div>
                          {screenshotSvg(styleConfig?.PrimaryButton?.color)}
                        </div>
                        <p style={{
                          color: styleConfig?.Input?.color || styleConfig?.Form?.color || BrandTheme?.primaryColor || themeConfig.primaryColor
                        }}>
                          {screenshot.name}
                        </p>
                        <button onClick={() => {
                          setScreenshot(null)
                        }}>
                          {deleteSvg(styleConfig?.PrimaryButton?.color)}
                        </button>
                      </div>
                    )}
                  {
                    file && (
                      <div className="q-fdov-file-name q-gen-file-name"
                        style={{
                          border: styleConfig?.Input?.border || "1px solid #ECECEC",
                        }}
                      >
                        <div>
                          {fileSvg(styleConfig?.PrimaryButton?.color)}
                        </div>
                        <p style={{
                          color: styleConfig?.Input?.color || styleConfig?.Form?.color || BrandTheme?.primaryColor || themeConfig.primaryColor
                        }}>
                          {file.name}
                        </p>
                        <button
                          onClick={() => {
                            setFile(null);
                            if (inputRef.current) {
                              inputRef.current.value = "";
                            }
                          }}>
                          {deleteSvg(styleConfig?.PrimaryButton?.color)}
                        </button>
                      </div>
                    )
                  }
                </div>
              );
            }
          })}
          <PrimaryButton
            children={PrimaryButtonText}
            style={buttonStyle}
            className="q-fdov-btn-continue"
            type="submit"
          />
        </>
      ) : (
        <div className="q-center">No data Found</div>
      )}
    </form>
  );
};

export default GeneralFeedbackContent;
